<template>
  <div class="whole">
    <div class="text_data" flexContainer>
      <div class="block" flexContainer>
        <div class="title">活跃组织（今日）</div>
        <div class="number">{{org_obj.active}}</div>
        <div class="tip">
          昨日活跃组织{{org_obj.yesterdayActive}}
          <span>{{org_obj.activeRate}}</span>
          <i class="trangle-up"></i>
        </div>
      </div>
      <div class="block" flexContainer>
        <div class="title">累计组织总数</div>
        <div class="number">{{org_obj.amount}}</div>
        <div class="tip"></div>
      </div>
      <div class="block newblock" v-for="n in 3" :key="n"></div>
    </div>
    <div class="org_chart">
      <div class="title" flexContainer>
        <div
          class="main"
          v-for="item in org_array"
          :key="item"
          :class="{org_title:isOrg == item.id}"
          @click="change_title(item.name,item.id)"
        >{{item.name}}</div>
        <div>
          <img src="@/assets/question.png" v-popover:popover1 />
        </div>
        <el-popover
          ref="popover1"
          placement="right-start"
          title
          width="400"
          trigger="hover"
          content
        >
          当前担当平台（包括担当办公、云盘、云资产、任务）所有组织数据
          <p>
            <b>付费组织：</b>组织内用户有付费操作，且现在仍在付费期间的组织。
          </p>
          <p>
            <b>活跃组织：</b>当前平台下，符合活跃定义的组织（不同产品去重）。
          </p>
          <p>
            <b>累计组织：</b>截止到当前时间，所有创建完成的组织。
          </p>
        </el-popover>
      </div>
      <div class="chart" flexContainer>
        <times></times>
        <chartone flex-1></chartone>
        <div class="way" flexContainer>
          <div class="line"></div>
          <div>{{isName}}</div>
        </div>
      </div>
    </div>
    <div class="org_chart">
      <div class="title" flexContainer>
        <div
          class="main"
          v-for="item in per_array"
          :key="item"
          :class="{org_title:isPer == item.id}"
          @click="change_per(item.name,item.id)"
        >{{item.name}}</div>
        <div>
          <img src="@/assets/question.png" v-popover:popover2 />
        </div>
        <el-popover
          ref="popover2"
          placement="right-start"
          title
          width="300"
          trigger="hover"
          content
        >
          <p>
            <b>周活跃率：</b>周活跃组织占截止本周累计组织的比例
          </p>
          <p>
            <b>月活跃率：</b>月活跃组织占截止本月累计组织的比例
          </p>
        </el-popover>
      </div>
      <div class="chart" flexContainer>
        <times></times>
        <chartwo flex-1></chartwo>
        <div class="way" flexContainer>
          <div class="line"></div>
          <div>{{isName_t}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { organization_info } from "../../api/orgnazition";
export default {
  components: {
    times: () =>
      import(/* webpackChunkName: "components" */ "./components/time.vue"),
    chartone: () =>
      import(/* webpackChunkName: "components" */ "./components/chart_one.vue"),
    chartwo: () =>
      import(/* webpackChunkName: "components" */ "./components/chart_two.vue")
  },
  data() {
    return {
      isOrg: 77101,
      isPer: 77111,
      isName: "活跃组织",
      isName_t: "组织活跃率",
      org_obj: {},
      org_array: [
        {
          name: "活跃组织",
          id: 77101
        },
        {
          name: "付费组织",
          id: 77102
        },
        {
          name: "累计组织",
          id: 77103
        }
      ],
      per_array: [
        {
          name: "组织活跃率",
          id: 77111
        },
        {
          name: "组织付费率",
          id: 77112
        },
        {
          name: "组织认证率",
          id: 77113
        }
      ]
    };
  },
  mounted() {
    this.info_fun();
  },
  methods: {
    //顶部数据
    info_fun() {
      organization_info()
        .then(res => {
          this.org_obj = res.data;
        })
        .catch(error => {});
    },
    //切换org_array
    change_title(name, id) {
      this.isOrg = id;
      this.isName = name;
    },
    change_per(name, id) {
      this.isPer = id;
      this.isName_t = name;
    }
  }
};
</script>
<style lang="scss" scoped>
.whole {
  .text_data {
    @include text-part;
  }
  .org_title {
    @include click-class;
  }
  .org_chart {
    @include chart-class;
  }
}
</style>